export const rolePermissions = {
    absences: 'absences',
    // admin: 'admin',
    admin: {
        access: 'admin.access',
        general: 'admin.general',
        activities: 'admin.activities',
        businessareas: 'admin.businessareas',
        deletecontract: 'admin.deletecontract',
        currencies: 'admin.currencies',
        exchangerate: 'admin.exchangerate',
        pspelement: 'admin.pspelement',
        holiday: 'admin.holiday',
        juno: 'admin.juno',
        locations: 'admin.locations',
        materialmaster: 'admin.materialmaster',
        news: 'admin.news',
        portfolios: 'admin.portfolios',
        customerstructure: 'admin.customerstructure',
        pricingpackage: 'admin.pricingpackage',
        commercialimporter: 'admin.commercialimporter',
        bviimporter: 'admin.bviimporter',
        externalimporter: 'admin.externalimporter',
        role: 'admin.role',
        accountinginternal: 'admin.accountinginternal',
        businesspartnerscdupdate: 'admin.businesspartnerscdupdate',
        employeescdupdate: 'admin.employeescdupdate',
        experiences: 'admin.experiences',
        serviceproducts: 'admin.serviceproducts',
        accessServicePackages: 'admin.accessServicePackages',
        servicedepartmentpackage: 'admin.servicedepartmentpackage',
        globalNotifications: 'admin.globalNotifications',
        projectConfirmation: 'admin.projectConfirmation'
    },
    bop: {
        createOne: 'bop.createOne',
        editOne: 'bop.editOne',
        readAll: 'bop.readAll'
    },
    businesspartner: {
        createOne: 'businesspartner.createOne',
        editOne: 'businesspartner.editOne',
        readAll: 'businesspartner.readAll'
    },
    capacities: 'capacities',
    costReport: 'costReport',
    absenceReport: 'absenceReport',
    workingHoursReport: 'workingHoursReport',
    productivityReport: 'productivityReport',
    contract: {
        readAll: 'contract.readAll',
        editOne: 'contract.editOne',
        createOne: 'contract.createOne',
        reviewAll: 'contract.reviewAll'
    },
    controlling: {
        salesFunnel: 'controlling.salesFunnel',
        quality: 'controlling.quality'
    },
    employee: {
        access: 'employee.access',
        readAll: 'employee.readAll',
        createOne: 'employee.createOne',
        editOne: 'employee.editOne',
        readOne: 'employee.readOne',
        experiences: 'employee.experiences',
        offboard: 'employee.offboard'
    },
    myceres: {
        settings: 'myceres.settings',
        experiences: 'myceres.experiences'
    },
    program: {
        readAll: 'program.readAll',
        statusReport: {
            readAll: 'program.statusReport.readAll',
            createOne: 'program.statusReport.createOne',
            editOne: 'program.statusReport.editOne'
        },
        classification: 'program.classification'
    },
    project: {
        readExtern: 'project.readExtern',
        readAll: 'project.readAll',
        readOwn: 'project.readOwn',
        editOne: 'project.editOne',
        createOne: 'project.createOne',
        nrs: 'project.nrs',
        accounting: 'project.accounting',
        preStaffing: {
            readAll: 'project.preStaffing.readAll',
            editOne: 'project.preStaffing.editOne'
        },
        document: {
            editOwn: 'project.document.editOwn'
        }
    },
    reports: 'reports',
    salesActivity: {
        readAll: 'salesActivity.readAll',
        editOne: 'salesActivity.editOne',
        createOne: 'salesActivity.createOne'
    },
    services: {
        readAll: 'services.readAll',
        editAll: 'services.editAll'
    },
    task: 'task',
    guest: 'guest',
    support: 'support',
    timesheet: 'timesheet',
    timesheetMonthClose: 'timesheetMonthClose',
    timesheetLock: 'timesheetLock',
    // workload: 'workload',
    workload: {
        readAll: 'workload.readAll',
        changeValues: 'workload.changeValues'
    },
    intelliSchedulePro: {
        // Employee permissions
        employee: {
            read: 'intelliSchedulePro.employees.read',
            readAll: 'intelliSchedulePro.employees.read.all',
            readWrite: 'intelliSchedulePro.employees.readWrite',
            readWriteAll: 'intelliSchedulePro.employees.readWrite.all',
            //Column level permissions
            readFieldsFinancial: 'intelliSchedulePro.employees.read.fields.financial',
            readFieldsExperiences: 'intelliSchedulePro.employees.read.fields.experiences'
        },
        // Project permissions
        projects: {
            read: 'intelliSchedulePro.projects.read',
            readAll: 'intelliSchedulePro.projects.read.all',
            readWrite: 'intelliSchedulePro.projects.readWrite',
            readWriteAll: 'intelliSchedulePro.projects.readWrite.all',
            //Column level permissions
            readFieldsFinancial: 'intelliSchedulePro.projects.read.fields.financial',
            readFieldsStaffing: 'intelliSchedulePro.projects.read.fields.staffing'
        },
        // Schedule permissions
        schedules: {
            //Column level permissions
            readFieldsFinancial: 'intelliSchedulePro.schedules.read.fields.financial'
        },
        // AI Assistant
        aiAssistant: {
            read: 'intelliSchedulePro.aiAssistant.read',
            readWrite: 'intelliSchedulePro.aiAssistant.readWrite'
        },
        // Scenario permissions
        scenarios: {
            read: 'intelliSchedulePro.scenario.read',
            readAll: 'intelliSchedulePro.scenario.read.all',
            readWrite: 'intelliSchedulePro.scenario.readWrite',
            readWriteAll: 'intelliSchedulePro.scenario.readWrite.all'
        }
    }
};
